import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import { GoogleAuth } from '../../authentication/google-auth';
import { resolveRouterPath, router } from '../../router';

// Landing page for the Google OAuth redirect. Runs the code exchange, then
// either lets app-index route on the user-profile-set event (success) or shows
// the error with a way back to the login page. Never sticks on the spinner:
// completeGoogleLogin always resolves to ok or an error.
@customElement('app-google-callback')
export class AppGoogleCallback extends LitElement {
  @state() private _error: string | null = null;

  static styles = css`
    :host {
      display: flex;
      min-height: 60vh;
      align-items: center;
      justify-content: center;
      padding: 24px;
    }
    .box {
      text-align: center;
      max-width: 420px;
      width: 100%;
    }
    .msg {
      margin-top: 16px;
      color: var(--s-ink-soft, #666);
    }
    sl-alert {
      text-align: left;
    }
    .back {
      margin-top: 16px;
    }
  `;

  connectedCallback(): void {
    super.connectedCallback();
    void this._run();
  }

  private async _run(): Promise<void> {
    const result = await GoogleAuth.completeGoogleLogin();
    if (!result.ok) {
      this._error = result.error;
    }
    // On success app-index's user-profile-set handler routes to the dashboard;
    // nothing more to do here.
  }

  private _backToLogin(): void {
    router.navigate(resolveRouterPath('login'));
  }

  render() {
    if (this._error) {
      return html`
        <div class="box">
          <sl-alert variant="danger" open>
            <sl-icon slot="icon" name="exclamation-octagon"></sl-icon>
            ${this._error}
          </sl-alert>
          <sl-button class="back" variant="primary" @click=${this._backToLogin}>
            Back to sign in
          </sl-button>
        </div>
      `;
    }
    return html`
      <div class="box">
        <sl-spinner style="font-size: 2rem"></sl-spinner>
        <p class="msg">Finishing Google sign-in…</p>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-google-callback': AppGoogleCallback;
  }
}
